import { EnhanceStorage } from '@halo/utils';
// TODO amo: Use client storage
export const enhancedClientStorage = new EnhanceStorage(window.localStorage);
